/**
 * Data-visualization palette — single source of truth (Sub 5).
 *
 * Consumers que NECESITAN string hex literal (no pueden consumir CSS vars):
 *   - `<input type="color">` value prop (color picker nativo)
 *   - Defaults persistidos en localStorage via useSettings
 *   - Fallbacks en JS antes de render (?? operators)
 *   - Arrays iterables para generar paletas en UI
 *
 * Para recharts/SVG/style inline preferir los CSS vars (`rgb(var(--color-chart-N))`,
 * envueltos: las vars guardan canales, no un color).
 * Hex aquí DUPLICAN los tokens en tailwind.config.js / index.css intencionalmente —
 * los CSS vars no resuelven dentro de `<input type="color">`.
 *
 * OJO: estos hex son los del tema OSCURO y NO siguen al tema. Es correcto para
 * lo que esta lista sirve —el valor que el usuario ELIGE y se persiste, que
 * debe ser un color estable y no uno que cambie al conmutar el tema— pero por
 * eso mismo no vale como fuente de color para pintar cromo de la UI.
 */

export const CHART_PALETTE = [
  "#6366f1", // chart-1
  "#22c55e", // chart-2
  "#f59e0b", // chart-3
  "#ef4444", // chart-4
  "#3b82f6", // chart-5
  "#a855f7", // chart-6
  "#f97316", // chart-7
  "#06b6d4", // chart-8
];

export const DEFAULT_GEOFENCE_COLOR = "#3b82f6"; // chart-5 / info
export const DEFAULT_TRAIL_COLOR = "#60a5fa"; // trail específico (intencional, no en chart palette)
export const FALLBACK_MUTED_COLOR = "#64748b"; // text-muted
export const GROUP_FALLBACK_COLOR = "#6366f1"; // chart-1

/**
 * Marker colors — semántica danger/warning/success (DashboardPage).
 * WARNING_MARKER y SUCCESS_MARKER NO coinciden con los tokens semánticos
 * (warning=#f59e0b ok, pero success=#10b981 difiere de #4ade80).
 * Se exportan como constantes para preservar look exacto pre-Sub 5.
 */
export const DANGER_MARKER = "#ef4444"; // = token danger
export const WARNING_MARKER = "#f59e0b"; // = token warning
export const SUCCESS_MARKER = "#4ade80"; // difiere de success (#10b981) — intencional
